<template>
  <div class="Footer">
    <div class="Footer-father">
      <div class="inner-contact inner-phone">
        关于我们 | 电话:{{ (contact && contact.tel) || "028-962377" }} |
        邮箱:{{ (contact && contact.email) || "scjb@scjb.gov.cn" }}
      </div>
      <div class="inner-contact">邮编:610031 | 地址:四川省成都市金牛区育新路196号22楼</div>
      <!-- <div class="inner-email">网络内容从业人员违法违规行为专用举报邮箱:zxjb@scjb.gov.cn</div> -->
      <div>
        <!-- (contact && contact.company) ||  -->
        {{
          "四川省网络治理研究中心（四川省网信人才发展研究中心）"
        }}版权所有
      </div>
      <div class="inner-address">
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">蜀ICP备13026939号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Contact',
  props: {
    contact: {
      type: Object,
      require: false
    }
  },
  data () {
    return {}
  },
  created () { },
  methods: {},
  computed: {
    ...mapState(['lang'])
  },
  watch: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.Footer {
  width: 100%;
  background-color: #101952;
  // padding:  0 7.3vw;
}
.Footer-father {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  div {
    font-size: 2.4vw;
    padding: 1vw 0;
    color: #c0c4e9;
  }
  .inner-contact {
    color: #eff7f9;
    font-size: 3.2vw;
  }
  .inner-email {
    padding: 4.8vw 0 1.6vw 0;
  }
  .inner-phone {
    padding-top: 8vw;
    padding-bottom: 3.73vw;
  }
  .inner-address {
    a{
      color: #c0c4e9;
    }
    padding: 1.6vw 0;
    padding-bottom: 8vw;
  }
}
</style>
